import { MapPin, Truck, Wrench } from 'lucide-react';

/**
 * Component to display local service zone information
 * ONLY used on Spa pages (category + detail)
 * NOT on pieces, accessories, or entretien pages
 */
const LocalServiceZone = ({ className = '' }) => {
  return (
    <div className={`bg-slate-50 border border-slate-200 rounded-xl p-5 ${className}`}>
      <div className="flex flex-col gap-3">
        {/* Line 1: Installation & SAV */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-[#1E3A5F] rounded-lg flex items-center justify-center flex-shrink-0">
            <Wrench className="w-4 h-4 text-white" />
          </div>
          <span className="text-slate-800 font-medium">Installation et SAV des spas assurés par nos équipes</span>
        </div>
        
        {/* Line 2: Zone d'intervention */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center flex-shrink-0">
            <MapPin className="w-4 h-4 text-white" />
          </div>
          <span className="text-slate-800 font-medium">Zone d'intervention : Nantes & Grand Ouest</span>
        </div>
        
        {/* Line 3: Livraison France */}
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 bg-emerald-500 rounded-lg flex items-center justify-center flex-shrink-0">
            <Truck className="w-4 h-4 text-white" />
          </div>
          <span className="text-slate-800 font-medium">Accessoires et pièces : livraison France entière</span>
        </div>
      </div>
    </div>
  );
};

export default LocalServiceZone;
